var React = require('react');

function House (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.8468 5.70533L6.49957 0.218335C6.43519 0.149613 6.35792 0.0949338 6.2724 0.0575822C6.18688 0.0202305 6.09488 0.000976562 6.00192 0.000976562C5.90897 0.000976562 5.81697 0.0202305 5.73145 0.0575822C5.64593 0.0949338 5.56866 0.149613 5.50428 0.218335L0.153169 5.70533C-0.120046 5.99533 -0.01759 6.23533 0.379548 6.23533H1.49388V10.4483C1.49388 10.7523 1.50656 11.0003 2.04421 11.0003H4.63975V6.77333H7.35824V11.0003H10.0836C10.4934 11.0003 10.5031 10.7533 10.5031 10.4483V6.23433H11.6194C12.0156 6.23433 12.1171 5.99633 11.8438 5.70433","fill":"currentColor"}));
}

House.defaultProps = {"viewBox":"0 0 12 10","fill":"none","style":{"color":"#39424A"}};

module.exports = House;

House.default = House;
